import { Configuration, ElementRegistry, ObjectElementFactory } from "duice";
import { CkeditorElement } from "./CkeditorElement";
/**
 * Ckeditor Factory
 */
export class CkeditorElementFactory extends ObjectElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    createElement(htmlElement, bindData, context) {
        return new CkeditorElement(htmlElement, bindData, context);
    }
}
/**
 * Static block
 */
(() => {
    // register
    ElementRegistry.register(`${Configuration.getNamespace()}-ckeditor`, new CkeditorElementFactory());
})();
//# sourceMappingURL=CkeditorElementFactory.js.map